import Color from '../Color.mjs'
import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.DARK_GREEN,
    mapIdProp: 'depMapId',
    mapTypeCode: 'DEP_MAP',
    name: '部署模型',
    type: 'CAT_DEP',
}
